export enum MenuTypes {
    regular = 'regular',
    premium = 'premium',
}